import { ensureResponseOk } from '../../../shared/errors/HttpError';
import type { ApiClient } from '../../auth/api/clients';
import type { CallSchedule } from '../types';

// guardedFetch はリフレッシュ失敗後の 401 をレスポンスとして返すため、
// 各関数で ensureResponseOk により HttpError へ統一する。

export const addJobNumber = async (apiClient: ApiClient, advertisementId: number, jobNumber: string): Promise<void> => {
  const res = await apiClient['call-settings'][':advertisementId']['job-numbers'].$post({
    param: { advertisementId: String(advertisementId) },
    json: { jobNumber },
  });
  await ensureResponseOk(res);
};

export const removeJobNumber = async (
  apiClient: ApiClient,
  advertisementId: number,
  jobNumber: string
): Promise<void> => {
  const res = await apiClient['call-settings'][':advertisementId']['job-numbers'][':jobNumber'].$delete({
    param: { advertisementId: String(advertisementId), jobNumber },
  });
  await ensureResponseOk(res);
};

export const updateSchedule = async (
  apiClient: ApiClient,
  advertisementId: number,
  schedule: CallSchedule
): Promise<void> => {
  const res = await apiClient['call-settings'][':advertisementId'].schedule.$put({
    param: { advertisementId: String(advertisementId) },
    json: schedule,
  });
  await ensureResponseOk(res);
};
